import en from 'date-fns/locale/en-CA';
import fr from 'date-fns/locale/fr-CA';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useEffect, useRef, useState } from 'libs/react';
import { React } from 'libs/react';
import './DateInput.scss';
registerLocale('fr', fr);
registerLocale('en', en);
/**
 * @component DateInput
 * @since 1.0.0
 * @hidden
 */
export function DateInput(props) {
    const { date, time, lang, ident, value, minDate, maxDate, required, disabled, placeholder, yearOnly, selectsRange, isClearable } = props;
    const node = useRef(null);
    const [startDate, setStartDate] = useState(value
        ? Array.isArray(value.split(',')) &&
            value.split(',').length > 1 &&
            value.split(',')[0]
            ? new Date(value === null || value === void 0 ? void 0 : value.split(',')[0])
            : new Date(value)
        : null);
    const [endDate, setEndDate] = useState(value
        ? Array.isArray(value.split(',')) &&
            value.split(',').length > 1 &&
            value.split(',')[1]
            ? new Date(value === null || value === void 0 ? void 0 : value.split(',')[1])
            : null
        : null);
    useEffect(() => {
        if (value) {
            const parts = value.split(',');
            if (parts.length > 1 && parts[0]) {
                setStartDate(new Date(parts[0]));
                setEndDate(parts[1] ? new Date(parts[1]) : null);
            }
            else {
                setStartDate(new Date(value));
                setEndDate(null);
            }
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
    }, [value]);
    useEffect(() => {
        if (props.focused && node.current) {
            node.current.setFocus();
        }
    }, [props.focused]);
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(date) {
        if (date == null ||
            (Array.isArray(date) && !date[0] && !date[1])) {
            setStartDate(null);
            setEndDate(null);
            if (props.onChange) {
                props.onChange(null);
            }
            return;
        }
        let start, end = null;
        if (Array.isArray(date)) {
            start = date[0];
            end = date[1];
            setStartDate(start);
            setEndDate(end);
        }
        if (!selectsRange) {
            if (props.onChange && date instanceof Date) {
                props.onChange(date);
            }
        }
        if (selectsRange && start && end) {
            if (props.onChange) {
                props.onChange([start, end]);
            }
        }
    }
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            if (selectsRange) {
                props.onBlur([startDate, endDate]);
            }
            else {
                props.onBlur(startDate);
            }
        }
    }
    const formats = [];
    if (date && !yearOnly) {
        formats.push('yyyy-MM-dd');
    }
    if (yearOnly) {
        formats.push('yyyy');
    }
    if (time && !yearOnly) {
        formats.push('hh:mm');
    }
    const format = formats.join(' ');
    const selected = !Array.isArray(value) && value && !isNaN(Date.parse(value))
        ? new Date(value)
        : null;
    const monthsFR = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    const monthsEN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const months = lang === 'en' ? monthsEN : monthsFR;
    const currentYear = new Date().getFullYear();
    const minYear = minDate ? minDate.getFullYear() : currentYear - 10;
    const maxYear = maxDate ? maxDate.getFullYear() : currentYear + 10;
    const years = Array.from({ length: maxYear - minYear + 1 }, (_, i) => minYear + i);
    function renderCustomHeader({ date, changeMonth, changeYear, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled, }) {
        return (React.createElement("div", { className: "react-datepicker__custom-header" },
            React.createElement("button", { type: "button", className: "react-datepicker__nav-btn react-datepicker__nav-btn--prev", onClick: decreaseMonth, disabled: prevMonthButtonDisabled, "aria-label": lang === 'en' ? 'Previous month' : 'Mois précédent' }),
            React.createElement("div", { className: "react-datepicker__header-selects" },
                React.createElement("div", { className: "react-datepicker__select-wrapper" },
                    React.createElement("select", { className: "react-datepicker__month-select", value: date.getMonth(), onChange: (e) => changeMonth(Number(e.target.value)) }, months.map((month, i) => (React.createElement("option", { key: month, value: i }, month))))),
                React.createElement("div", { className: "react-datepicker__select-wrapper" },
                    React.createElement("select", { className: "react-datepicker__year-select", value: date.getFullYear(), onChange: (e) => changeYear(Number(e.target.value)) }, years.map((year) => (React.createElement("option", { key: year, value: year }, year)))))),
            React.createElement("button", { type: "button", className: "react-datepicker__nav-btn react-datepicker__nav-btn--next", onClick: increaseMonth, disabled: nextMonthButtonDisabled, "aria-label": lang === 'en' ? 'Next month' : 'Mois suivant' })));
    }
    return (React.createElement(DatePicker, { id: ident, ref: node, locale: lang, selected: selectsRange ? startDate : selected, required: required, disabled: disabled, placeholderText: placeholder, showTimeSelect: time && !yearOnly, showYearPicker: yearOnly, timeIntervals: 15, dateFormat: format, minDate: minDate, maxDate: maxDate, onChange: onChange, onSelect: onChange, onBlur: onBlur, onCalendarOpen: props.onCalendarOpen, onCalendarClose: props.onCalendarClose, isClearable: isClearable, selectsRange: selectsRange, startDate: startDate, endDate: endDate, popperPlacement: "bottom-start", portalId: props.portalId, fixedHeight: true, renderCustomHeader: yearOnly ? undefined : renderCustomHeader }));
}
